// File: services/recipe.js
import { toast } from "react-toastify";
const url = `${process.env.REACT_APP_BASEURL}/api/admin/daily-checkin-question`;

export const GetQuestionListApi = async () => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "getall"}),
    });
    // console.log("Response from API:", response);

    if (!response.ok) throw new Error("Failed to fetch recipe list.");
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
  }
};

export const handleDeleteQuestion = async (questionId, refreshCallback) => {
  if (window.confirm("Are you sure you want to delete this Question ?")) {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "delete", data:{_id: questionId} }),
      });

      const data = await response.json();
      if (data.success) toast.success("Question deleted successfully");
      else toast.warning("Question deleted, but response was unexpected");
      refreshCallback();
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong while deleting.");
    }
  }
};

export const submitQuestionApi = async (questionData) => {
  const actionType = questionData._id ? "edit" : "add";

  // 🔒 Basic validations (frontend safety)
  if (!questionData.question) {
    toast.error("Question is required");
    return null;
  }

  if (!Array.isArray(questionData.options) || questionData.options.length < 2) {
    toast.error("At least 2 options are required");
    return null;
  }

  const hasInvalidOption = questionData.options.some(
    (opt) => !opt.label || !opt.key || !opt.value
  );

  if (hasInvalidOption) {
    toast.error("Please fill label, key and value for all options");
    return null;
  }

  const payload = {
    action: actionType,
    data: {
      questionText: questionData.question,
      options: questionData.options, // {label, key, value}[]
    },
  };

  if (questionData._id) {
    payload.data._id = questionData._id;
  }

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (response.ok && result?.success !== false) {
      toast.success(
        questionData._id
          ? "Check-in question updated successfully"
          : "Check-in question added successfully"
      );
      return result;
    } else {
      toast.error(result.message || "Failed to save check-in question");
      return null;
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Something went wrong while saving the question");
    return null;
  }
};

export const getQuestionByIdApi = async (id) => {
  try {
    const payload = {
      action: "getById",
      data: { _id: id }
    }
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    if (result.success) return result;
    else toast.error("Failed to load recipe");
  } catch (err) {
    console.error("Fetch by ID error:", err);
  }
};
